import { FC } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { CardProps } from "@mui/material/Card/Card";

type ICardCore = CardProps & {
  sxStyle?: SxProps<Theme>;
};

export const CardCore: FC<ICardCore> = ({ sxStyle, children }) => {
  return (
    <Box
      sx={{
        background: "#ffffff",

        margin: "1rem",
        padding: { xs: ".7rem", sm: "16px" },

        border: "1px solid #E4E4E4FF",

        borderRadius: "12px",
        overflow: "hidden",

        ...sxStyle,
      }}
    >
      {children}
    </Box>
  );
};
